var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrapefruit = function SvgGrapefruit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#grapefruit_svg__a)",
    d: "M133.019 59c-102.94-.5-102.94 152 1.492 152 112.744 0 99.469-151.51-1.492-152"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#grapefruit_svg__b)",
    d: "M94.277 119.256c2.46.87 3.43 3.7 2.17 6.319s-4.27 4.039-6.731 3.169-3.421-3.7-2.17-6.319 4.28-4.039 6.73-3.169"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grapefruit_svg__a",
    x1: 62.162,
    x2: 204.547,
    y1: 165.856,
    y2: 100.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grapefruit_svg__b",
    x1: 94.529,
    x2: 89.32,
    y1: 119.94,
    y2: 128.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3596C2"
  })))));
};
export default SvgGrapefruit;